import { useMemo, useState } from 'react';
import { ElContext } from './context';

export const ElContextProvider = ({ children }) => {
  const [el, setEl] = useState(null);
  const ctxVal = useMemo(() => [el, setEl], [el]);

  return <ElContext.Provider value={ctxVal}>{children}</ElContext.Provider>;
};
